<template>
  <CContainer>
    <CRow>
      <CCol md="6">
        <LazyLoadSelect
          :is-multiple="false"
          :is-processing="false"
          :classes="[
            {
              'is-invalid':
                v$.form.location.$error || reqResponse.errors.location
            },
            'mb-3'
          ]"
          :selected="form.location"
          type="locations"
          placeholder="Select Location"
          @changed="selectLocation"
        >
          <template #footer>
            <div
              v-if="v$.form.$error && v$.form.location.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
          </template>
        </LazyLoadSelect>
      </CCol>
      <CCol v-if="isActiveAutoCheckInModule" md="4">
        <div class="form-group">
          <input
            v-if="(currentRoom && currentRoom.room_pin) || showPinTooltip"
            type="text"
            class="form-control location-pin"
            v-model="form.pin"
            :class="{
              'is-invalid':
                v$.form.pin.$error ||
                reqResponse.errors['teacher_pin'] ||
                reqResponse.errors['maxLength']
            }"
            v-c-tooltip="{
              content:
                'This PIN is associated with the room, so changing it will change it globally for this room.',
              active: isEditable,
              placement: 'bottom-start'
            }"
            placeholder="PIN"
            :disabled="!isEditable"
            @focus="isEditable = true"
            @blur="isEditable = false"
          />

          <input
            v-else
            type="text"
            v-model="form.pin"
            class="form-control location-pin"
            :class="{
              'is-invalid':
                v$.form.pin.$error ||
                reqResponse.errors['teacher_pin'] ||
                reqResponse.errors['maxLength']
            }"
            placeholder="PIN"
            :disabled="!isEditable"
            @blur="isEditable = false"
          />
          <div
            v-if="reqResponse.errors['teacher_pin']"
            class="invalid-feedback"
          >
            This PIN is assigned to another room or adult.
          </div>
          <!-- <div
            v-if="v$.form.$error && v$.form.pin.required.$invalid"
            class="invalid-feedback"
          >
            This field is required
          </div> -->
          <div
            v-if="v$.form.$error && v$.form.pin.maxLength.$invalid"
            class="invalid-feedback"
          >
            The pin may not be greater than 6 characters.
          </div>
        </div>
      </CCol>
      <CCol md="2">
        <div
          class="d-flex align-items-center justify-content-center justify-content-md-start mt-0 mb-5 mb-md-0 mt-md-1"
        >
          <button
            v-if="isActiveAutoCheckInModule"
            :class="{ inversed: isEditable }"
            class="btn btn-edit me-2"
            @blur="setEditable"
            @click="toggleEditable"
          >
            <i class="flaticon-edit" />
          </button>
          <button class="btn btn-danger" @click="deleteForm">
            <i class="flaticon-trash" />
          </button>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required, maxLength } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"

export default {
  name: "LocationForm",
  components: {
    LazyLoadSelect
  },
  emits: ["deleteLocation"],
  setup() {
    return { v$: useVuelidate() }
  },
  props: ["currentRoom", "index"],
  data() {
    return {
      showPinTooltip: false,
      form: {
        location: null,
        pin: null
      },
      isEditable: true,
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    form: {
      location: {
        required
      },
      pin: {
        maxLength: maxLength(6)
      }
    }
  },
  computed: {
    isValid() {
      return !this.v$.form.$invalid
    },
    ...mapGetters({
      isActiveAutoCheckInModule: "schools/isActiveAutoCheckInModule",
      userAssignRooms: "rooms/userAssignRooms"
    })
  },
  watch: {
    currentRoom() {
      const room = this.currentRoom.room
      this.form.location = {
        value: {
          id: room.id,
          type: "App\\Models\\Room"
        },
        label: room.name,
        capacity: room.capacity ? !!room.capacity : null
      }
      this.form.pin = this.currentRoom ? this.currentRoom.room_pin : null
      this.isEditable = false
    }
  },
  created() {
    if (this.currentRoom) {
      const room = this.currentRoom.room
      this.form.location = {
        value: {
          id: room.id,
          type: "App\\Models\\Room"
        },
        label: room.name,
        capacity: room.capacity ? !!room.capacity : null
      }
      this.form.pin = this.currentRoom ? this.currentRoom.room_pin : null
      this.isEditable = false
    }
  },
  methods: {
    touch() {
      this.v$.$touch()
    },
    selectLocation(value) {
      this.form.location = value
      this.form.pin = value.owner_pin
      this.showPinTooltip = !!(value && value.owner_pin)
    },
    toggleEditable() {
      this.isEditable = !this.isEditable
    },
    deleteForm() {
      this.$emit("deleteLocation")
    },
    setEditable(e) {
      this.isEditable = !!(
        e.relatedTarget && e.relatedTarget.classList.contains("location-pin")
      )
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    }
  }
}
</script>

<style></style>
